module.exports = __webpack_public_path__ + "img/org.f0bb148c.png";